import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class MaxDigitsService {
  constructor() {}

  maxTenDigits(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value;
      if (value.length < 1 || value.length > 10) {
        return { maxTenDigits: true };
      } else {
        return null;
      }
    };
  }
}
